/* src/app/pages/companypage/companypage.component.scss */
/*# sourceMappingURL=companypage.component.css.map */
